import { cn } from 'lib/utils';

/** A top-bar destination. The current one is a grey pill in semibold ink; the rest stay quiet. */
export function portalNavLinkClass(active: boolean): string {
  return cn(
    'inline-flex h-10 items-center gap-1 whitespace-nowrap rounded-md px-3 text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
    active
      ? 'bg-muted font-semibold text-foreground'
      : 'font-medium text-foreground/75 hover:bg-muted hover:text-foreground',
  );
}
